export default __webpack_public_path__ + "css/adminServicesEditor.bundle.css";